export default function Footer() {
  return (
    <footer className="py-8 px-4 sm:px-6 lg:px-8 bg-slate-900">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo and Service Name */}
          <div className="flex items-center gap-3">
            <span className="text-xl font-bold text-white">サクッとHP</span>
          </div>

          {/* Company Info */}
          <div className="text-center md:text-right">
            <p className="text-slate-400">運営：合同会社Lill</p>
            <p className="text-slate-400">
              お問い合わせ：
              <a 
                href="mailto:cham.nft@gmail.com"
                className="text-cyan-400 hover:text-cyan-300 ml-2 cursor-pointer"
              >
                cham.nft@gmail.com
              </a>
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-6 border-t border-slate-800 text-center">
          <p className="text-slate-500">
            © 2024 合同会社Lill. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}